import BonesAndJoints from '../assets/focusareas-green/bones-and-joint.svg';
import Energy from '../assets/focusareas-green/energy.svg';
import Focus from '../assets/focusareas-green/focus.svg';
import SportsPerformance from '../assets/focusareas-green/sports-performance.svg';
import Mood from '../assets/focusareas-green/mood.svg';
import Sleep from '../assets/focusareas-green/sleep.svg';
import Stress from '../assets/focusareas-green/stress.svg';
import Digestion from '../assets/focusareas-green/digestion.svg';
import ImmuneSystem from '../assets/focusareas-green/immune-system.svg';
import Skin from '../assets/focusareas-green/skin.svg';
import Nails from '../assets/focusareas-green/nail.svg';
import Heart from '../assets/focusareas-green/heart.svg';
import Eyes from '../assets/focusareas-green/eyes.svg';
import Hair from '../assets/focusareas-green/hair.svg';
import MusclePain from '../assets/focusareas-green/muscle-pain.svg';
import Menopause from '../assets/focusareas-green/perimenopause-menopause-symptoms.svg';

export const FOCUS_AREAS = [
  {
    code: 'energy',
    name: ['Energy', 'Energie', 'Énergie'],
    img: Energy,
  },
  {
    code: 'focus',
    name: ['Focus', 'Konzentration', 'Concentration'],
    img: Focus,
  },
  {
    code: 'sport-performance',
    name: ['Sport Performance', 'Sportliche Leistung', 'Performance sportive'],
    img: SportsPerformance,
  },
  {
    code: 'mood',
    name: ['Mood', 'Stimmung', 'Humeur'],
    img: Mood,
  },
  {
    code: 'sleep',
    name: ['Sleep', 'Schlaf', 'Sommeil'],
    img: Sleep,
  },
  {
    code: 'stress',
    name: ['Stress', 'Stress'],
    img: Stress,
  },
  {
    code: 'digestion',
    name: ['Digestion', 'Verdauung'],
    img: Digestion,
  },
  {
    code: 'immune-system',
    name: ['Immune System', 'Immunsystem', 'Système immunitaire'],
    img: ImmuneSystem,
  },
  {
    code: 'skin',
    name: ['Skin', 'Haut', 'Peau'],
    img: Skin,
  },
  {
    code: 'nails',
    name: ['Nails', 'Nägel', 'Ongles'],
    img: Nails,
  },
  {
    code: 'heart',
    name: ['Heart', 'Herz', 'Cœur'],
    img: Heart,
  },
  {
    code: 'eyes',
    name: ['Eyes', 'Augen', 'Yeux'],
    img: Eyes,
  },
  {
    code: 'muscle-pain',
    name: ['Muscle Pain', 'Muskelschmerzen', 'Douleurs musculaires'],
    img: MusclePain,
  },
  {
    code: 'bones-and-joints',
    name: ['Bones and Joints', 'Knochen und Gelenke', 'Os et articulations'],
    img: BonesAndJoints,
  },
  {
    code: 'hair',
    name: ['Hair', 'Haare', 'Cheveux'],
    img: Hair,
  },
  {
    code: 'perimenopause-menopause-symptoms',
    name: [
      'Perimenopause / Menopause Symptoms',
      'Wechseljahresbeschwerden (Perimenopause / Menopause)',
      'Symptômes de périménopause / ménopause',
    ],
    img: Menopause,
  },
];
